import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mc-collab-doc-bar',
  templateUrl: './collab-doc-bar.component.html',
  styleUrls: ['./collab-doc-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollabDocBarComponent {
  @Input() docSize?: number;
  @Input() itemCount?: number;
  @Input() itemPluralize?: string = 'line';
  /** Whether or not to show the items in the toolbar. This can be used to hide the items until all the necessary data is loaded. */
  @Input() showItems?: boolean = true;
}
